import type { PrintWatermark } from '#shared/types';
import { Checkbox } from '#client/components/ui/Checkbox';
import { TextField } from '#client/components/ui/TextField';
import { ColorField } from '../controls/ColorField';
import { NumberField } from '../controls/NumberField';

interface WatermarkSectionProps {
  watermark: PrintWatermark;
  onChange: (patch: Partial<PrintWatermark>) => void;
}

export function WatermarkSection({ watermark, onChange }: WatermarkSectionProps) {
  return (
    <>
      <Checkbox
        label="Print a watermark"
        checked={watermark.enabled}
        onChange={(event) => onChange({ enabled: event.target.checked })}
      />

      {watermark.enabled && (
        <>
          <TextField
            label="Text"
            value={watermark.text}
            onChange={(event) => onChange({ text: event.target.value })}
            helpText="Sized to the page automatically. Blank prints nothing."
          />
          <ColorField
            label="Colour"
            value={watermark.color}
            onChange={(color) => onChange({ color })}
          />
          <div className="c-builder__grid">
            <NumberField
              label="Opacity"
              value={watermark.opacity}
              onChange={(opacity) => onChange({ opacity })}
              min={0}
              max={1}
              step={0.01}
              helpText="Much above 0.12 and it competes with the results."
            />
            <NumberField
              label="Angle"
              unit="°"
              value={watermark.angle}
              onChange={(angle) => onChange({ angle })}
              min={-90}
              max={90}
            />
          </div>
          <Checkbox
            label="Bold"
            checked={watermark.bold}
            onChange={(event) => onChange({ bold: event.target.checked })}
          />
        </>
      )}
    </>
  );
}
